import type { TranslationKey } from 'shared/lib/i18n.tsx';
import { almatyStage, type RunnerStageAssets } from './almaty/almatyStage.ts';

export interface RunnerStage {
  id: string;
  labelKey: TranslationKey;
  previewUrl: string;
  assets: RunnerStageAssets;
}

export const RUNNER_STAGES: RunnerStage[] = [
  {
    id: 'almaty',
    labelKey: 'map.almaty',
    previewUrl: 'https://1t.gg/storage/groover-media/media/1780394865846-img_low_wall.png',
    assets: almatyStage,
  },
];

export function getRunnerStage(id: string): RunnerStage {
  return RUNNER_STAGES.find((s) => s.id === id) ?? RUNNER_STAGES[0];
}
